import { ErrorMessage, Field } from "formik";
import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import {
  handleInputToUppercase,
  handleKeyPressAlphabets,
  handleKeyPressNumeric,
} from "../../../CommonUtilities/Validations/RegularExpAndVar";
import moment from "moment";
import ReactSelect from "react-select";
import Swal from "sweetalert2";
import { getMinimumEligibleDOB } from "../../../CommonUtilities/Validations/Validations";
import { getMaxExperience } from "../../../CommonUtilities/CommonFunctions/CommonFunction";

const PersonalDetails = (props) => {
  const {
    Formik,
    isRead,
    Castes,
    disableField,
    handleCasteChange,
    selectedValue,
    subCastes,
    setSelectedsubcasteValue,
    selectedsubcasteValue
  } = props;

  function onClearFieldValue(name) {
    Formik.setFieldValue(name, "");
  }
  const today = moment();
  const cutoffDate = moment("2025-07-01");
const maxDate = moment(cutoffDate).subtract(18, "years").format("YYYY-MM-DD");
const minDate = getMinimumEligibleDOB({
  caste: Formik.values.caste,
  isEws: Formik.values.isEws,
  isPh: Formik.values.isPh,
  isExServiceMen: Formik.values.isExServiceMen,
}).format("YYYY-MM-DD");

  return (
    <React.Fragment>
     <div className='personal-block'>
      <div className="personal-head">
        <span>Personal Details</span>
      </div>
      <div className="personal-row pb-3">
        <Row className="row">
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="aadhaarNo">
              <Form.Label className="input-lable mb-2">
                Aadhaar No. <font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="aadhaarNo"
                className="input-field form-control"
                readOnly={isRead}
                disabled={disableField || isRead}
                maxLength="12"
                onKeyPress={(e) => {
                  handleKeyPressNumeric(e);
                }}
                placeholder="Enter Aadhaar No"
              />
            </Form.Group>
            <ErrorMessage
              name="aadhaarNo"
              component="div"
              className="text-error"
            />
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="mobileNo">
              <Form.Label className="input-lable mb-2">
                Mobile No.<font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="mobileNo"
                maxLength="10"
                className="input-field form-control"
                readOnly={isRead}
                onKeyPress={(e) => {
                  handleKeyPressNumeric(e);
                }}
                placeholder="Enter Mobile No"
                disabled={disableField || isRead}
              />
              <ErrorMessage
                name="mobileNo"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="firstName">
              <Form.Label className="input-lable mb-2">
                 Name <font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="applicantName"
                maxLength="50"
                // readOnly={isRead}
                className="input-field form-control"
                onInput={(e) => {
                  handleInputToUppercase(e);
                }}
                onKeyPress={(e) => {
                  handleKeyPressAlphabets(e);
                }}
                placeholder="Enter Name"
                disabled={disableField}
              />
              <ErrorMessage
                name="applicantName"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="surName">
              <Form.Label className="input-lable mb-2">
                 SurName <font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="surName"
                maxLength="50"
                // readOnly={isRead}
                className="input-field form-control"
                onInput={(e) => {
                  handleInputToUppercase(e);
                }}
                onKeyPress={(e) => {
                  handleKeyPressAlphabets(e);
                }}
                placeholder="Enter surName"
                disabled={disableField}
              />
              <ErrorMessage
                name="surName"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
           <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="gender">
              <Form.Label className="input-lable mb-2">
                Gender<font color="red">*</font>
              </Form.Label>
              <div className="form-border">
                <label>
                  <Field
                    type="radio"
                    name="gender"
                    value="Male"
                    className="form-sub me-1"
                    disabled={disableField}
                     onClick={() => {
            Formik.setFieldValue('gender', 'Male');
            Swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Male candidates are not eligible for this recruitment...!"
            }).then(() => {
              Formik.setFieldValue('gender', '');
            });
          }}
                  />
                  Male&nbsp;
                </label>
                <label>
                  <Field
                    type="radio"
                    value="Female"
                    name="gender"
                    className="form-sub me-1"
                    disabled={disableField}
                     onClick={() => {
            Formik.setFieldValue('gender', 'Female');
          }}
                  />
                  Female&nbsp;
                </label>
                {/* <label>
                  <Field
                    type="radio"
                    value="Transgender"
                    name="gender"
                    className="form-sub me-1"
                    disabled={disableField}
                  />
                  Transgender
                </label> */}
              </div>
              <ErrorMessage
                name="gender"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
           <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <div className="input-div position-relative">
              <Form.Group controlId="caste">
                <Form.Label className="input-lable mb-2">
                  Caste<font color="red">*</font>
                </Form.Label>
                {isRead ? (
                  <Field as="select" className="input-field form-control" name="caste"
                    onChange={(e) => {
                      let val = e.target.value;
                      handleCasteChange(val);
                      Formik.setFieldValue("isEws", "");
                    }}
                  >
                    {" "}
                    <option>Select</option>
                    {Castes?.map((ds, i) => {
                      return (
                        <option key={i} value={ds}>
                          {ds}
                        </option>
                      );
                    })}
                  </Field>
                ) : (
                  <Field as={ReactSelect} name="caste" options={Castes} isDisabled={disableField}
                    onChange={(selectedOption) => {
                      handleCasteChange(selectedOption);
                    }}
                    value={selectedValue} isSearchable={true} placeholder="Select" className="input-field"
                  />
                )}
                <ErrorMessage name="caste" component="div" className="text-error" />
              </Form.Group>{" "}
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <div className="input-div position-relative">
              <Form.Group controlId="caste">
                <Form.Label className="input-lable mb-2">
                  Sub Caste<font color="red">*</font>
                </Form.Label>
                <Field
                  as={ReactSelect}
                  name="subCasteCode"
                  options={subCastes}
                  isDisabled={disableField}
                  onChange={(selectedOption) => {
                    Formik.setFieldValue("subCasteCode", selectedOption?.value);
                    setSelectedsubcasteValue(selectedOption);
                  }}
                  value={selectedsubcasteValue}
                  isSearchable={true}
                  placeholder="Select"
                  className="input-field"
                />
                <ErrorMessage
                  name="subCasteCode"
                  component="div"
                  className="text-error"
                />
              </Form.Group>{" "}
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="dob">
              <Form.Label className="input-lable mb-2">
                Date of Birth<font color="red">*</font>
              </Form.Label>

              <Field type="date" name="dob" className="input-field form-control"
                disabled={disableField}
                min={minDate} max={maxDate}
              // max={moment("2006-07-02").format("YYYY-MM-DD")} for dsc
              />
            </Form.Group>
            <ErrorMessage name="dob" component="div" className="text-error" />
          </Col>
         
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="maritalStatus">
              <Form.Label className="input-lable mb-2">
                Marital Status<font color="red">*</font>
              </Form.Label>
              <div className="form-border">
                <label>
                  <Field
                    type="radio"
                    value="Married"
                    name="maritalStatus"
                    className="form-sub me-1"
                    disabled={disableField}
                  />
                  Married &nbsp;
                </label>
                <label>
                  <Field
                    type="radio"
                    value="Unmarried"
                    name="maritalStatus"
                    className="form-sub me-1"
                    disabled={disableField}
                  />
                  Unmarried
                </label>
              </div>
            </Form.Group>
            <ErrorMessage
              name="maritalStatus"
              component="div"
              className="text-error"
            />
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="lastName">
              <Form.Label className="input-lable mb-2">
                Father's Name<font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="fatherName"
                maxLength="50"
                className="input-field form-control"
                onInput={(e) => {
                  handleInputToUppercase(e);
                }}
                onKeyPress={(e) => {
                  handleKeyPressAlphabets(e);
                }}
                placeholder="Enter Father's Name"
                disabled={disableField}
              />
              <ErrorMessage
                name="fatherName"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="lastName">
              <Form.Label className="input-lable mb-2">
                Mother's Name<font color="red">*</font>
              </Form.Label>
              <Field
                type="text"
                name="motherName"
                maxLength="50"
                className="input-field form-control"
                placeholder="Enter Mother's Name"
                disabled={disableField}
                onInput={(e) => {
                  handleInputToUppercase(e);
                }}
                onKeyPress={(e) => {
                  handleKeyPressAlphabets(e);
                }}
              />
              <ErrorMessage
                name="motherName"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
         
          {Formik?.values?.caste === "OC" && (
            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
              <Form.Group controlId="isEws">
                <Form.Label className="input-lable mb-2">
                  Are You Eligible for (EWS)<font color="red">*</font>
                </Form.Label>
                <div className="form-border">
                  <Field
                    type="radio"
                    value="true"
                    name="isEws"
                    disabled={disableField}
                    className="form-sub me-1"
                  />
                  Yes &nbsp;&nbsp;&nbsp;&nbsp;
                  <Field
                    type="radio"
                    value="false"
                    name="isEws"
                    disabled={disableField}
                    className="form-sub me-1"
                  />
                  No
                </div>
                <ErrorMessage
                  name="isEws"
                  component="div"
                  className="text-error"
                />
                
              </Form.Group>
            </Col>
          )}
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="isExServiceMen">
              <Form.Label className="input-lable mb-2">
                Ex-Service Woman<font color="red">*</font>
              </Form.Label>
              <div className="form-border">
                <Field
                  type="radio"
                  value="true"
                  name="isExServiceMen"
                  onClick={() => {
                    onClearFieldValue("exService");
                  }}
                  className="form-sub me-1"
                  disabled={disableField}
                />
                Yes &nbsp;&nbsp;&nbsp;&nbsp;
                <Field
                  type="radio"
                  value="false"
                  name="isExServiceMen"
                  className="form-sub me-1"
                  disabled={disableField}
                  onClick={() => {
                    onClearFieldValue("exService");
                  }}
                />
                No
              </div>
              <ErrorMessage
                name="isExServiceMen"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          {/* {Formik?.values?.isExServiceMen === "true" && (
            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
              <Form.Group controlId="exService">
                <Form.Label className="input-lable mb-2">
                  Length of Service<font color="red">*</font>
                </Form.Label>
                <Field
                  as="select"
                  className="input-field form-control"
                  name="exService"
                >
                  {" "}
                  <option value="">Select</option>
                  {Array.from({ length: 12 }, (_, i) => i + 1).map((num) => (
                    <option key={num} value={num} disabled={num > getMaxExperience(Formik.values.dob  ? Formik.values.dob : null)}>
                      {num}
                    </option>
                  ))}
                  <option value="13" disabled={13 > getMaxExperience(Formik.values.dob  ? Formik.values.dob : null)}>13 +</option>
                </Field>
              </Form.Group>
              <ErrorMessage
                name="exService"
                component="div"
                className="text-error"
              />
            </Col>
          )} */}
          {Formik?.values?.isExServiceMen === "true" && (
  <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
    <Form.Group controlId="exService">
      <Form.Label className="input-lable mb-2">
        Length of Service<font color="red">*</font>
      </Form.Label>

      <Field
        as="select"
        className="input-field form-control"
        name="exService">
        <option value="">Select</option>

        {(() => {
          const maxExp = getMaxExperience(
            Formik.values.dob ? Formik.values.dob : null
          );

          return Array.from({ length: maxExp }, (_, i) => i + 1).map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ));
        })()}

        {getMaxExperience(Formik.values.dob) >= 13 && (
          <option value="13">13 +</option>
        )}
      </Field>
    </Form.Group>

    <ErrorMessage
      name="exService"
      component="div"
      className="text-error"
    />
  </Col>
)}
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
            <Form.Group controlId="isPh">
              <Form.Label className="input-lable mb-2">
                If Differently Abled(PH)<font color="red">*</font>
              </Form.Label>
              <div className="form-border">
                <Field
                  type="radio"
                  value="true"
                  disabled={disableField}
                  onClick={() => {
                    onClearFieldValue("isVh");
                    onClearFieldValue("isOh");
                    onClearFieldValue("isHi");
                    onClearFieldValue("isMi");
                    // onClearFieldValue("isScribe");
                    onClearFieldValue("vhPercentage");
                    onClearFieldValue("hiPercentage");
                    onClearFieldValue("ohPercentage");
                    onClearFieldValue("miPercentage");
                  }}
                  name="isPh"
                  className="form-sub me-1"
                />
                Yes &nbsp;&nbsp;&nbsp;&nbsp;
                <Field
                  type="radio"
                  value="false"
                  disabled={disableField}
                  name="isPh"
                  className="form-sub me-1"
                  onClick={() => {
                    onClearFieldValue("isVh");
                    onClearFieldValue("isOh");
                    onClearFieldValue("isHi");
                    onClearFieldValue("isMi");
                    // onClearFieldValue("isScribe");
                    onClearFieldValue("vhPercentage");
                    onClearFieldValue("hiPercentage");
                    onClearFieldValue("ohPercentage");
                    onClearFieldValue("miPercentage");
                  }}
                />
                No
              </div>
              <ErrorMessage
                name="isPh"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
          {Formik?.values?.isPh === "true" && (
            <React.Fragment>
              <Col
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                xs={12}
                sm={12}
                className="mb-3"
              >
                <Form.Group controlId="isVh">
                  <Form.Label className="input-lable mb-2">
                    {" "}
                    PH Details <font color="red">*</font>
                  </Form.Label>
                  <div
                    className="form-border"
                    style={{ padding: " 10px 20px 10px 20px" }}
                  >
                    <Row>
                      <Col md={9} lg={9} xl={9} xxl={9} xs={12} sm={12}>
                        <Field
                          name="isVh"
                          type="checkbox"
                          disabled={disableField}
                          onChange={() => {
                            onClearFieldValue("vhPercentage");
                          }}
                          className="form-sub"
                        />
                        &nbsp; VISUALLY IMPAIRED(VI) &emsp;
                      </Col>
                      {Formik?.values.isVh === true && (
                        <Col md={3} lg={3} xl={3} xxl={3} xs={12} sm={12}>
                          <Field
                            as="select"
                            className="input-field form-control mb-2"
                            name="vhPercentage"
                            disabled={disableField}
                          >
                            <option value="0">Select</option>
                            <option value="40-45">40-45 %</option>
                            <option value="46-50">46-50 %</option>
                            <option value="51-55">51-55 %</option>
                            <option value="56-60">56-60 %</option>
                            <option value="61-65">61-65 %</option>
                            <option value="66-70">66-70 %</option>
                            <option value="Above 70">Above 70 %</option>
                          </Field>
                          <ErrorMessage
                            name="vhPercentage"
                            component="div"
                            className="text-error"
                          />
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col md={9} lg={9} xl={9} xxl={9} xs={12} sm={12}>
                        <Field
                          type="checkbox"
                          disabled={disableField}
                          name="isHi"
                          onChange={() => {
                            onClearFieldValue("hiPercentage");
                          }}
                          className="form-sub"
                        />
                        &nbsp; HEARING IMPAIRED(HI)
                      </Col>
                      {Formik?.values.isHi === true && (
                        <Col md={3} lg={3} xl={3} xxl={3} xs={12} sm={12}>
                          <Field
                            as="select"
                            className="input-field form-control mb-2"
                            name="hiPercentage"
                            disabled={disableField}
                          >
                            <option value="0">Select</option>
                            <option value="40-45">40-45 %</option>
                            <option value="46-50">46-50 %</option>
                            <option value="51-55">51-55 %</option>
                            <option value="56-60">56-60 %</option>
                            <option value="61-65">61-65 %</option>
                            <option value="66-70">66-70 %</option>
                            <option value="Above 70">Above 70 %</option>
                          </Field>
                          <ErrorMessage
                            name="hiPercentage"
                            component="div"
                            className="text-error"
                          />
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col md={9} lg={9} xl={9} xxl={9} xs={12} sm={12}>
                        <Field
                          type="checkbox"
                          disabled={disableField}
                          name="isOh"
                          className="form-sub"
                          onChange={() => {
                            onClearFieldValue("ohPercentage");
                          }}
                        />
                        &nbsp; ORTHOPEDICALLY HANDICAPPED(OH)
                      </Col>
                      {Formik?.values.isOh === true && (
                        <Col md={3} lg={3} xl={3} xxl={3} xs={12} sm={12}>
                          <Field
                            as="select"
                            className="input-field form-control mb-2"
                            name="ohPercentage"
                            disabled={disableField}
                          >
                            <option value="0">Select</option>
                            <option value="40-45">40-45 %</option>
                            <option value="46-50">46-50 %</option>
                            <option value="51-55">51-55 %</option>
                            <option value="56-60">56-60 %</option>
                            <option value="61-65">61-65 %</option>
                            <option value="66-70">66-70 %</option>
                            <option value="Above 70">Above 70 %</option>
                          </Field>
                          <ErrorMessage
                            name="ohPercentage"
                            component="div"
                            className="text-error"
                          />
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col md={9} lg={9} xl={9} xxl={9} xs={12} sm={12}>
                        <Field
                          type="checkbox"
                          name="isMi"
                          className="form-sub"
                          disabled={disableField}
                          onChange={() => {
                            onClearFieldValue("miPercentage");
                          }}
                        />
                        &nbsp; MENTAL DISABILITY / MULTIPLE DISABILITY (MD)
                      </Col>
                      {Formik?.values.isMi === true && (
                        <Col md={3} lg={3} xl={3} xxl={3} xs={12} sm={12}>
                          <Field
                            as="select"
                            className="input-field form-control mb-2"
                            name="miPercentage"
                            disabled={disableField}
                          >
                            <option value="0">Select</option>
                            <option value="40-45">40-45 %</option>
                            <option value="46-50">46-50 %</option>
                            <option value="51-55">51-55 %</option>
                            <option value="56-60">56-60 %</option>
                            <option value="61-65">61-65 %</option>
                            <option value="66-70">66-70 %</option>
                            <option value="Above 70">Above 70 %</option>
                          </Field>
                          <ErrorMessage
                            name="miPercentage"
                            component="div"
                            className="text-error"
                          />
                        </Col>
                      )}
                      <ErrorMessage
                        name="isMi"
                        component="div"
                        className="text-error"
                      />
                    </Row>
                  </div>
                </Form.Group>
              </Col>
              {/* <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12}>
                <Form.Group controlId="isScribe">
                  <Form.Label className="input-lable mb-2">
                    Whether scribe required<font color="red">*</font>
                  </Form.Label>
                  <div className="form-border">
                    <Field
                      type="radio"
                      value="true"
                      name="isScribe"
                      className="form-sub me-1"
                      disabled={disableField}
                    />
                    Yes &nbsp;&nbsp;&nbsp;&nbsp;
                    <Field
                      type="radio"
                      value="false"
                      name="isScribe"
                      className="form- me-1"
                      disabled={disableField}
                    />
                    No
                  </div>
                  <ErrorMessage
                    name="isScribe"
                    component="div"
                    className="text-error"
                  />
                </Form.Group>
              </Col> */}
            </React.Fragment>
          )}
        </Row>
      </div></div>
    </React.Fragment>
  );
};

export default PersonalDetails;
